import conn from "@/store/utils/connection";
import setoranWorkshopApi from "../apiEndPoint";
import resulter from "@/store/utils/resulter";
import state from "./state";
import transaksiAPI from "@/store/utils/api-route/transaksiAPI";

const actions = {
    queryFilterSetoranKasWorkshop({ commit, rootGetters }) {
        let getFilter = rootGetters["filterGlobalModule/getFilter"];
        let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"];

        let query = {
            sort_by: getFilter.sortBy,
            order_by: getFilter.orderBy,
            limit: state.pagination.limit,
            offset: state.pagination.offset,
        };

        Object.keys(getFilterItem).forEach((key) => {
            if (getFilterItem[key].length > 0) {
                switch (key) {
                    case "karyawan":
                        query.idkaryawan = getFilterItem[key];
                        break;
                    case "akunKeuanganGlobal":
                        query.akun_setoran = [getFilterItem[key]];
                        break;
                    case "statusKonfirmasi":
                        query.status = getFilterItem[key];
                        break;
                    case "workshop":
                        query.idworkshop = getFilterItem[key];
                        break;
                }
            }
            if (key === "periode") {
                query.filter_by = getFilterItem[key].filterBy;
                if (getFilterItem[key].filterBy === "periode") {
                    query.tanggal_awal = getFilterItem[key].startDate;
                    query.tanggal_akhir = getFilterItem[key].endDate;
                }

                if (getFilterItem[key].filterBy === "tahun") {
                    query.tahun = getFilterItem[key].year;
                }

                if (getFilterItem[key].filterBy === "bulan") {
                    query.bulan = getFilterItem[key].month;
                }
            }
        });

        if (state.isSearch) {
            query.key = state.search.key;
        }

        return query;
    },

    async fetchSetoranKasWorkshopList({ commit, dispatch }) {
        try {
            let query = await dispatch("queryFilterSetoranKasWorkshop");
            const res = await conn.get(setoranWorkshopApi.list, query);
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                let objQuery = conn.setQueryString(query);
                commit("setQuerySetoranWorkshopList", objQuery);
                commit("setSetoranKasWorkshopList", res.data);
                return resulter.successResult();
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async fetchSetoranKasWorkshopDetail({ commit, dispatch }, id) {
        try {
            let query = {
                idtransfer: id,
            };
            const res = await conn.get(setoranWorkshopApi.detail, query);
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                commit("setSetoranKasWorkshopDetail", res.data);
                return resulter.successResult();
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async confirm({ commit, dispatch }, form) {
        try {
            const res = await conn.post(setoranWorkshopApi.confirm, form, conn.contentType.form);
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                return resulter.successResult(res.data.msg);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },

    // export
    async export({ commit, dispatch }, payload) {
        try {
            let query = await dispatch("queryFilterSetoranKasWorkshop", payload.id);
            let formData = new FormData();
            formData.append("type", payload.type);
            formData.append("filter_json", JSON.stringify(query));

            const res = await conn.post(transaksiAPI.export.job, formData, conn.contentType.form);
            if (!res.data) {
                throw res;
            }
            if (res.data.code === 200) {
                localStorage.setItem("key_export_setoran_kas_workshop", "export:job:keuangan:setoran_workshop");
                return resulter.successResult(res.data.msg);
            } else {
                return resulter.errorResult(res.data.msg, res.data.data);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async exportTrack({ commit }) {
        try {
            let keyExport = localStorage.getItem("key_export_setoran_kas_workshop");
            if (keyExport === null) {
                return resulter.errorResult();
            }
            let query = {
                key: keyExport,
            };
            const res = await conn.get(transaksiAPI.export.track, query);
            if (!res.data) {
                throw res;
            }
            if (res.data.code === 200) {
                return resulter.successResult(res.data.msg, res.data.data);
            } else {
                return resulter.errorResult(res.data.msg, res.data.data);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async exportDeleteCluster({ commit }, key) {
        try {
            let query = {
                key: key,
            };
            const res = await conn.get(transaksiAPI.export.delete.cluster, query);
            if (!res.data) {
                throw res;
            }
            if (res.data.code === 200) {
                return resulter.successResult(res.data.msg, res.data.data);
            } else {
                return resulter.errorResult(res.data.msg, res.data.data);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },

    async exportDeleteMaster({ commit }) {
        try {
            let keyExport = localStorage.getItem("key_export_setoran_kas_workshop");
            let query = {
                key: keyExport,
            };
            const res = await conn.get(transaksiAPI.export.delete.master, query);
            if (!res.data) {
                throw res;
            }
            if (res.data.code === 200) {
                localStorage.removeItem("key_export_setoran_kas_workshop");
                return resulter.successResult(res.data.msg, res.data.data);
            } else {
                return resulter.errorResult(res.data.msg, res.data.data);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    deleteData({ commit }, { idtransfer }) {
        let formData = new FormData();
        formData.append("idtransfer", idtransfer);
        return conn.post(setoranWorkshopApi.delete, formData, conn.contentType.form);
    },
};

export default actions;
